export default {"src":"/_next/static/media/wallet-icon.6c426651.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};